const translations = {
    en: {
        reach_us: {
            map_banner: {
                header: "WE ARE WAITING FOR YOU",
                title: "How to reach ${hotel}",
                text: "Ready to go? Here you will find all the information to reach us easily."
            }
        }
    },
    de: {
        reach_us: {
            map_banner: {
                header: "WIR FREUEN UNS AUF IHREN BESUCH",
                title: "Wie man erreicht ${hotel}",
                text: "Reisefertig? Hier finden Sie alle Informationen, um uns einfach zu erreichen."
            }
        }
    },
    es: {
        reach_us: {
            map_banner: {
                header: "LA ESTAMOS ESPERANDO",
                title: "Como llegar ${hotel}",
                text: "Està listo ? Aqui podrà encontrar las indicaciones para llegar fácilmente."
            }
        }
    },
    fr: {
        reach_us: {
            map_banner: {
                header: "NOUS VOUS ATTENDONS",
                title: "Comment atteindre le ${hotel}",
                text: "Prêt à partir? Ici vous trouverez toutes les informations pour nous rejoindre plus facilement."
            }
        }
    },
    it: {
        reach_us: {
            map_banner: {
                header: "NON VEDIAMO L'ORA DI ACCOGLIERTI",
                title: "Come raggiungere il ${hotel}",
                text: "Pronto a partire? Qui trovi tutte le indicazioni per raggiungerci con facilità."   
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/reach_us/MapBanner.js